import React from 'react';
import Slide from '@material-ui/core/Slide';
import { TransitionProps } from '@material-ui/core/transitions';

export const Transition = React.forwardRef((props: TransitionProps, ref: React.Ref<unknown>): JSX.Element => {
  return <Slide direction="left" ref={ ref } { ...props } />;
});
